/**
 * PATH: packages/ui/src/components/sidebar-chrome/sidebarChromeShortcut.ts
 * FILE_ID: UI-SIDEBAR-SHORTCUT-001
 * PURPOSE: Decide whether Ctrl/Cmd+B may collapse the left menu.
 * WHY: That chord is also Bold in the email composer. The window listener
 *      must leave the event alone while an editor has focus.
 * RELATED: UI-SIDEBAR-SHORTCUT-TEST-001
 */

/** Typing surface: native fields, contenteditable, or role=textbox (compose). */
export function isEditorShortcutTarget(target: EventTarget | null): boolean {
  const el = elementFromTarget(target)
  if (!el) return false
  const tag = el.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (el instanceof HTMLElement && el.isContentEditable) return true
  // A widget inside the composer can be the event target while the
  // ProseMirror node (role=textbox / contenteditable) stays the editor.
  return el.closest('[role="textbox"], [contenteditable="true"], [contenteditable=""]') !== null
}

function elementFromTarget(target: EventTarget | null): Element | null {
  if (!target) return null
  if (target instanceof Element) return target
  if (target instanceof Node) return target.parentElement
  return null
}
